import { Box, Stack } from "@mui/material";
import ComingSoonFeature from "../../components/common/ComingSoonFeature";

const Marketing = () => {
  return (
    <Box>
      <Stack spacing={4}>
        {/* Calendar Feature */}
        <Box>
          <ComingSoonFeature
            featureName="MARKETING"
            skeletonType="list"
            description="Advanced marketing management and analytics coming soon!"
            height={650}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default Marketing;
